import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/Services/Common/common.service';
import { SearchService } from 'src/app/Services/search.service';
import { HttpClient } from '@angular/common/http';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { MatDialog } from '@angular/material';
import { LoginComponent } from 'src/app/login/login.component';
import { PopupComponent } from '../popup/popup.component';
declare var $: any;
@Component({
  selector: 'app-pid',
  templateUrl: './pid.component.html',
  styleUrls: ['./pid.component.css']
})
export class PIDComponent implements OnInit {
  pidForm: FormGroup;
  progressBarShow: boolean = false;
  masteruri = this.properties.WebAPIipAndPort.concat(this.properties.BSSAPI);
  ProjectTypeList: any;

  Task1GridAdapter: any;
  Task1GridColumns: any[];
  Task1GridSource: any;
  Task1GridToolBar: any;

  Task2GridAdapter: any;
  Task2GridColumns: any[];
  Task2GridSource: any;
  Task2GridToolBar: any;

  Task3GridAdapter: any;
  Task3GridColumns: any[];
  Task3GridSource: any;
  Task3GridToolBar: any;

  Task41GridAdapter: any;
  Task4GridColumns: any[];
  Task4GridSource: any;
  Task4GridToolBar: any;

  Task5GridAdapter: any;
  Task5GridColumns: any[];
  Task5GridSource: any;
  Task5GridToolBar: any;

  @ViewChild('Task1Grid', { static: false }) Task1Grid: jqxGridComponent;
  @ViewChild('Task2Grid', { static: false }) Task2Grid: jqxGridComponent;
  @ViewChild('Task3Grid', { static: false }) Task3Grid: jqxGridComponent;
  @ViewChild('Task4Grid', { static: false }) Task4Grid: jqxGridComponent;
  @ViewChild('Task5Grid', { static: false }) Task5Grid: jqxGridComponent;


  constructor(private formBuilder: FormBuilder,
    private alert: AlertDialogService,
    private httpRequestService: HttpRequestService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private properties: PropertiesService,
    private datePipe: DatePipe,
    private searchService: SearchService,
    private gridService: CommonGridService,
    public dialog: MatDialog,
    public commonService: CommonService) { this.createForm(); }
  ngOnInit() {
    this.getProjectTypeList();
    this.Task1gridInint();
    this.Task2gridInint();
    this.Task3gridInint();
    this.Task4gridInint();
    this.Task5gridInint();
    this.router.navigate(['/home', { outlets: { search: ['searchPID'] } }]);
    this.route.queryParams.subscribe(params => {
      if (params.TransID) {
        this.clearPID();
        this.GetPIDData(params.TransID);
      }
    });
    this.searchService.refreshSearch();
    $(".Task1Grid").jqxGrid('updatebounddata');
    $(".Task2Grid").jqxGrid('updatebounddata');
    $(".Task3Grid").jqxGrid('updatebounddata');
    $(".Task4Grid").jqxGrid('updatebounddata');
    $(".Task5Grid").jqxGrid('updatebounddata');
  }
  getProjectTypeList() {
    return new Promise((resolve) => {
      this.http.get(this.masteruri + '/common/getCombo', { params: { type: 'ProjectType' } }).subscribe((res: any) => {
        if (res != null) {
          resolve(res.body);
          this.ProjectTypeList = res.result
        }
        else {
          alert("No Records Found")
        }
        console.log('Done');
      });
    });
  }
  GetPIDData(transID) {
    this.GetPID(transID).then((list: any) => {
      let headerDetails: any;
      let task1Details: any;
      let task2Details: any;
      let task3Details: any;
      let task4Details: any;
      let task5Details: any;

      headerDetails = list.result[0][0];
      task1Details = list.result[1];
      task2Details = list.result[2];
      task3Details = list.result[3];
      task4Details = list.result[4];
      task5Details = list.result[5];
      
      task1Details.forEach(element => {
        this.pidForm.get("Task1Name").setValue(element.TaskName);
      });
      task2Details.forEach(element => {
        this.pidForm.get("Task2Name").setValue(element.TaskName);
      });
      task3Details.forEach(element => {
        this.pidForm.get("Task3Name").setValue(element.TaskName);
      });
      task4Details.forEach(element => {
        this.pidForm.get("Task4Name").setValue(element.TaskName);
      });
      task5Details.forEach(element => {
        this.pidForm.get("Task5Name").setValue(element.TaskName);
      });
     

      this.Task1GridSource.localdata = task1Details;
      this.Task1GridAdapter = new jqx.dataAdapter(this.Task1GridSource);
      $(".Task1Grid").jqxGrid('updatebounddata');

      this.Task2GridSource.localdata = task2Details;
      this.Task2GridAdapter = new jqx.dataAdapter(this.Task2GridSource);
      $(".Task2Grid").jqxGrid('updatebounddata');

      this.Task3GridSource.localdata = task3Details;
      this.Task3GridAdapter = new jqx.dataAdapter(this.Task3GridSource);
      $(".Task3Grid").jqxGrid('updatebounddata');

      this.Task4GridSource.localdata = task4Details;
      this.Task41GridAdapter = new jqx.dataAdapter(this.Task4GridSource);
      $(".Task4Grid").jqxGrid('updatebounddata');

      this.Task5GridSource.localdata = task5Details;
      this.Task5GridAdapter = new jqx.dataAdapter(this.Task5GridSource);
      $(".Task5Grid").jqxGrid('updatebounddata');


      this.pidForm.get("TransID").setValue(headerDetails.TransID);

      this.pidForm.get("ProjectName").setValue(headerDetails.ProjectName);

      this.pidForm.get("ProjectCode").setValue(headerDetails.ProjectCode);
      if (headerDetails.ClientName == 'null') {
        headerDetails.ClientName = '';
      }
      this.pidForm.get("ClientName").setValue(headerDetails.ClientName);
      if (headerDetails.ClientLocation == 'null') {
        headerDetails.ClientLocation = '';
      }
      this.pidForm.get("ClientLocation").setValue(headerDetails.ClientLocation);
      if (headerDetails.ClientContacts == 'null') {
        headerDetails.ClientContacts = '';
      }
      this.pidForm.get("ClientContacts").setValue(headerDetails.ClientContacts);

      // this.pidForm.get("ProjectType").setValue(headerDetails.ProjectType);
      this.pidForm.get("ProjectType").setValue(Number(headerDetails.ProjectType));
      if (headerDetails.ProjectDescr == 'null') {
        headerDetails.ProjectDescr = '';
      }
      this.pidForm.get("ProjectDescr").setValue(headerDetails.ProjectDescr);

      if (headerDetails.ProjectFrom == "1900-01-01") {
        this.pidForm.get("ProjectFrom").setValue('');
      } else {
        this.pidForm.get("ProjectFrom").setValue(headerDetails.ProjectFrom);
      }
      if (headerDetails.ProjectTo == "1900-01-01") {
        this.pidForm.get("ProjectTo").setValue('');
      } else {
        this.pidForm.get("ProjectTo").setValue(headerDetails.ProjectTo);
      }
      // this.pidForm.get("ProjectFrom").setValue(headerDetails.ProjectFrom);

      // this.pidForm.get("ProjectTo").setValue(headerDetails.ProjectTo);

      this.pidForm.get("ProjectValue").setValue(headerDetails.ProjectValue);

      this.pidForm.get("AMCCost").setValue(headerDetails.AMCCost);
      if (headerDetails.ProjectOwner == 'null') {
        headerDetails.ProjectOwner = '';
      }
      this.pidForm.get("ProjectOwner").setValue(headerDetails.ProjectOwner);
      if (headerDetails.BizReferredBy == 'null') {
        headerDetails.BizReferredBy = '';
      }
      this.pidForm.get("BizReferredBy").setValue(headerDetails.BizReferredBy);

      this.pidForm.get("TeamSize").setValue(headerDetails.TeamSize);
      if (headerDetails.TeamDescr == 'null') {
        headerDetails.TeamDescr = '';
      }
      this.pidForm.get("TeamDescr").setValue(headerDetails.TeamDescr);
      if (headerDetails.TeamEffort == 'null') {
        headerDetails.TeamEffort = '';
      }
      this.pidForm.get("TeamEffort").setValue(headerDetails.TeamEffort);

      this.pidForm.get("ExternalConsultant").setValue(headerDetails.ExternalConsultant);
      if (headerDetails.ExtNameRole == 'null') {
        headerDetails.ExtNameRole = '';
      }
      this.pidForm.get("ExtNameRole").setValue(headerDetails.ExtNameRole);

      this.pidForm.get("isSpecific").setValue(headerDetails.isSpecific);
      if (headerDetails.SpecificDetails == 'null') {
        headerDetails.SpecificDetails = '';
      }
      this.pidForm.get("SpecificDetails").setValue(headerDetails.SpecificDetails);
      if (headerDetails.DocListTMLPS == 'null') {
        headerDetails.DocListTMLPS = '';
      }
      this.pidForm.get("DocListTMLPS").setValue(headerDetails.DocListTMLPS);
      if (headerDetails.DocListClient == 'null') {
        headerDetails.DocListClient = '';
      }
      this.pidForm.get("DocListClient").setValue(headerDetails.DocListClient);
      if (headerDetails.PayoutSchedule == 'null') {
        headerDetails.PayoutSchedule = '';
      }
      this.pidForm.get("PayoutSchedule").setValue(headerDetails.PayoutSchedule);
      if (headerDetails.InvoiceSchedule == 'null') {
        headerDetails.InvoiceSchedule = '';
      }
      this.pidForm.get("InvoiceSchedule").setValue(headerDetails.InvoiceSchedule);

      this.pidForm.get("GrossProfit").setValue(headerDetails.GrossProfit);


    });
  }
  GetPID(transID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.masteruri + "/pid/getPID?transID=" + transID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
  createForm() {
    this.pidForm = this.formBuilder.group({
      TransID: [],
      ProjectName: [],
      ProjectCode: [],
      ClientName: [],
      ClientLocation: [],
      ClientContacts: [],
      ProjectType: [],
      ProjectDescr: [],
      ProjectFrom: [],
      ProjectTo: [],
      ProjectValue: [],
      AMCCost: [],
      ProjectOwner: [],
      BizReferredBy: [],
      TeamSize: [],
      TeamDescr: [],
      TeamEffort: [],
      ExternalConsultant: [],
      ExtNameRole: [],
      isSpecific: [],
      SpecificDetails: [],
      DocListTMLPS: [],
      DocListClient: [],
      PayoutSchedule: [],
      InvoiceSchedule: [],
      GrossProfit: [],
      CreatedBy: [],
      Created: [],
      ApprovedBy: [],
      Approved: [],
      isActive: [],
      Task1Name: [],
      Task2Name: [],
      Task3Name: [],
      Task4Name: [],
      Task5Name: [],
      // AprovedBy: [],
      // PreparedOn: [],
      // ApprovedOn: []
    })
  }
  savePID() {
    this.progressBarShow = true;
    var frmObj = this.pidForm.getRawValue();
    if (!frmObj.TransID || frmObj.TransID == null || frmObj.TransID == '') {
      frmObj.TransID = '';
    }
    if (!frmObj.ProjectType || frmObj.ProjectType == null || frmObj.ProjectType == '') {
      frmObj.ProjectType = 0;
    }
    if (!frmObj.AMCCost || frmObj.AMCCost == null || frmObj.AMCCost == '') {
      frmObj.AMCCost = 0;
    }
    if (!frmObj.TeamSize || frmObj.TeamSize == null || frmObj.TeamSize == '') {
      frmObj.TeamSize = 0;
    }
    if (!frmObj.ExternalConsultant || frmObj.ExternalConsultant == null || frmObj.ExternalConsultant == '') {
      frmObj.ExternalConsultant = 0;
    }
    if (!frmObj.isSpecific || frmObj.isSpecific == null || frmObj.isSpecific == '') {
      frmObj.isSpecific = 0;
    }
    if (!frmObj.GrossProfit || frmObj.GrossProfit == null || frmObj.GrossProfit == '') {
      frmObj.GrossProfit = 0;
    }
    if (!frmObj.ProjectFrom || frmObj.ProjectFrom == null || frmObj.ProjectFrom == '') {
      frmObj.ProjectFrom = '';
    } else {
      frmObj.ProjectFrom = this.datePipe.transform(frmObj.ProjectFrom, 'MM-dd-yyyy');
    }
    if (!frmObj.ProjectTo || frmObj.ProjectTo == null || frmObj.ProjectTo == '') {
      frmObj.ProjectTo = '';
    } else {
      frmObj.ProjectTo = this.datePipe.transform(frmObj.ProjectTo, 'MM-dd-yyyy');
    }
    if (!frmObj.Approved || frmObj.Approved == null || frmObj.Approved == '') {
      frmObj.Approved = '';
    }
    if (!frmObj.Created || frmObj.Created == null || frmObj.Created == '') {
      frmObj.Created = 0;
    }
    if (!frmObj.AprovedBy || frmObj.AprovedBy == null || frmObj.AprovedBy == '') {
      frmObj.AprovedBy = 0;
    }
    if (!frmObj.ProjectValue || frmObj.ProjectValue == null || frmObj.ProjectValue == '') {
      frmObj.ProjectValue = 0;
    }
    if (!frmObj.ApprovedBy || frmObj.ApprovedBy == null || frmObj.ApprovedBy == '') {
      frmObj.ApprovedBy = 0;
    }
    if (!frmObj.ProjectDescr || frmObj.ProjectDescr == null || frmObj.ProjectDescr == '') {
      frmObj.ProjectDescr = '';
    }
    if (!frmObj.Task1Name || frmObj.Task1Name == null || frmObj.Task1Name == '') {
      frmObj.Task1Name = '';
    }
    if (!frmObj.Task2Name || frmObj.Task2Name == null || frmObj.Task2Name == '') {
      frmObj.Task2Name = '';
    }
    if (!frmObj.Task3Name || frmObj.Task3Name == null || frmObj.Task3Name == '') {
      frmObj.Task3Name = '';
    }
    if (!frmObj.Task4Name || frmObj.Task4Name == null || frmObj.Task4Name == '') {
      frmObj.Task4Name = '';
    }
    if (!frmObj.Task5Name || frmObj.Task5Name == null || frmObj.Task5Name == '') {
      frmObj.Task5Name = '';
    }


    if (!frmObj.SpecificDetails || frmObj.SpecificDetails == null || frmObj.SpecificDetails == '') {
      frmObj.SpecificDetails = '';
    }
    if (!frmObj.ClientName || frmObj.ClientName == null || frmObj.ClientName == '') {
      frmObj.ClientName = '';
    }
    if (!frmObj.PayoutSchedule || frmObj.PayoutSchedule == null || frmObj.PayoutSchedule == '') {
      frmObj.PayoutSchedule = '';
    }
    if (!frmObj.DocListClient || frmObj.DocListClient == null || frmObj.DocListClient == '') {
      frmObj.DocListClient = '';
    }
    if (!frmObj.ClientContacts || frmObj.ClientContacts == null || frmObj.ClientContacts == '') {
      frmObj.ClientContacts = '';
    }
    if (!frmObj.ExtNameRole || frmObj.ExtNameRole == null || frmObj.ExtNameRole == '') {
      frmObj.ExtNameRole = '';
    }
    if (!frmObj.ClientLocation || frmObj.ClientLocation == null || frmObj.ClientLocation == '') {
      frmObj.ClientLocation = '';
    }
    if (!frmObj.BizReferredBy || frmObj.BizReferredBy == null || frmObj.BizReferredBy == '') {
      frmObj.BizReferredBy = '';
    }

    if (!frmObj.DocListTMLPS || frmObj.DocListTMLPS == null || frmObj.DocListTMLPS == '') {
      frmObj.DocListTMLPS = '';
    }

    if (!frmObj.TeamDescr || frmObj.TeamDescr == null || frmObj.TeamDescr == '') {
      frmObj.TeamDescr = '';
    }
    if (!frmObj.TeamEffort || frmObj.TeamEffort == null || frmObj.TeamEffort == '') {
      frmObj.TeamEffort = '';
    }
    if (!frmObj.InvoiceSchedule || frmObj.InvoiceSchedule == null || frmObj.InvoiceSchedule == '') {
      frmObj.InvoiceSchedule = '';
    }
    if (!frmObj.ProjectOwner || frmObj.ProjectOwner == null || frmObj.ProjectOwner == '') {
      frmObj.ProjectOwner = '';
    }
    frmObj.CreatedBy = 1;
    frmObj.Created = '';
    frmObj.isActive = 1;

    var taskDetails1Grid = $('.Task1Grid').jqxGrid('getrows');
    var taskDetails2Grid = $('.Task2Grid').jqxGrid('getrows');
    var taskDetails3Grid = $('.Task3Grid').jqxGrid('getrows');
    var taskDetails4Grid = $('.Task4Grid').jqxGrid('getrows');
    var taskDetails5Grid = $('.Task5Grid').jqxGrid('getrows');

    frmObj.Detail1 = taskDetails1Grid;
    frmObj.Detail2 = taskDetails2Grid;
    frmObj.Detail3 = taskDetails3Grid;
    frmObj.Detail4 = taskDetails4Grid;
    frmObj.Detail5 = taskDetails5Grid;

    frmObj.Detail1.forEach(task => {
      task.isActive = 1;
      task.TaskID = 1;
      task.TaskName = frmObj.Task1Name;
      if(!task.Designation || task.Designation == null){
        task.Designation = '';
      }
      if(!task.NoOfHour || task.NoOfHour == null){
        task.NoOfHour = 0;
      }
      if(!task.RatePerHour || task.RatePerHour == null){
        task.RatePerHour = 0;
      }
      if(!task.Cost || task.Cost == null){
        task.Cost = 0;
      }
      if(!task.Role || task.Role == null){
        task.Role = 0;
      }
      if(!task.UserID || task.UserID == null){
        task.UserID = 0;
      }
    });
    frmObj.Detail2.forEach(task1 => {
      task1.isActive = 1;
      task1.TaskID = 2;
      task1.TaskName = frmObj.Task2Name;
      if(!task1.Designation || task1.Designation == null){
        task1.Designation = '';
      }
      if(!task1.NoOfHour || task1.NoOfHour == null){
        task1.NoOfHour = 0;
      }
      if(!task1.RatePerHour || task1.RatePerHour == null){
        task1.RatePerHour = 0;
      }
      if(!task1.Cost || task1.Cost == null){
        task1.Cost = 0;
      }
      if(!task1.Role || task1.Role == null){
        task1.Role = 0;
      }
      if(!task1.UserID || task1.UserID == null){
        task1.UserID = 0;
      }
    });
    // var taskDetails3Grid = $('.Task3Grid').jqxGrid('getrows');
    frmObj.Detail3.forEach(task => {
      task.isActive = 1;
      task.TaskID = 3;
      task.TaskName = frmObj.Task3Name;
      if(!task.Designation || task.Designation == null){
        task.Designation = '';
      }
      if(!task.NoOfHour || task.NoOfHour == null){
        task.NoOfHour = 0;
      }
      if(!task.RatePerHour || task.RatePerHour == null){
        task.RatePerHour = 0;
      }
      if(!task.Cost || task.Cost == null){
        task.Cost = 0;
      }
      if(!task.Role || task.Role == null){
        task.Role = 0;
      }
      if(!task.UserID || task.UserID == null){
        task.UserID = 0;
      }
    });
    // var taskDetails4Grid = $('.Task4Grid').jqxGrid('getrows');
    frmObj.Detail4.forEach(task => {
      task.isActive = 1;
      task.TaskID = 4;
      task.TaskName = frmObj.Task4Name;
      if(!task.Designation || task.Designation == null){
        task.Designation = '';
      }
      if(!task.NoOfHour || task.NoOfHour == null){
        task.NoOfHour = 0;
      }
      if(!task.RatePerHour || task.RatePerHour == null){
        task.RatePerHour = 0;
      }
      if(!task.Cost || task.Cost == null){
        task.Cost = 0;
      }
      if(!task.Role || task.Role == null){
        task.Role = 0;
      }
      if(!task.UserID || task.UserID == null){
        task.UserID = 0;
      }
    });
    // var taskDetails5Grid = $('.Task5Grid').jqxGrid('getrows');
    frmObj.Detail5.forEach(task => {
      task.isActive = 1;
      task.TaskID = 5;
      task.TaskName = frmObj.Task5Name;
      if(!task.Designation || task.Designation == null){
        task.Designation = '';
      }
      if(!task.NoOfHour || task.NoOfHour == null){
        task.NoOfHour = 0;
      }
      if(!task.RatePerHour || task.RatePerHour == null){
        task.RatePerHour = 0;
      }
      if(!task.Cost || task.Cost == null){
        task.Cost = 0;
      }
      if(!task.Role || task.Role == null){
        task.Role = 0;
      }
      if(!task.UserID || task.UserID == null){
        task.UserID = 0;
      }
    });
    

    var header = { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    
    this.httpRequestService.post(this.masteruri + "/pid/loadPID", frmObj, header).then((response: any) => {
      if (response.status == 200) {
        this.alert.openSnackBar(response.result[0].Message, '1');
        this.clearPID();
        this.searchService.refreshSearch();
      } else if (response.status == 400) {
        this.alert.openSnackBar(response.result, '0');
      }
    }, (error: any) => {
      console.log('Booking save Error Occured', error);
      this.alert.openSnackBar('Error in Updation', '0');
    });
    this.progressBarShow = false;
  }
  clearPID() {
    // const dialogRef = this.dialog.open(PopupComponent, {
    //   width: '99%',
    //   data: { rptId: 1, rptSPName: '' }
    //   // , disableClose: true
    // });
    this.pidForm.reset();
    $(".Task1Grid").jqxGrid('clear');
    $(".Task2Grid").jqxGrid('clear');
    $(".Task3Grid").jqxGrid('clear');
    $(".Task4Grid").jqxGrid('clear');
    $(".Task5Grid").jqxGrid('clear');
    this.pidForm.enable();
    this.progressBarShow = false;
  }
  editPID() {
    this.pidForm.enable();
    this.progressBarShow = false;
  }

  //#region  Grids
  Task1gridInint() {
    let userautourl = this.masteruri + '/userMaster/user-auto';
    let userLabelInput: any;
    this.Task1GridColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, editable: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'PDetailID', datafield: 'PDetailID', width: '5%', hidden: true },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        {
          text: 'UserName <span style="color:red">*</span>', width: '13%', datafield: 'UserName', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            userLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, userautourl, 'UserName', undefined, function (obj) {
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'Designation', obj.Designation);
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'NoOfHour', 0);
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'Role', obj.RoleName);
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'RatePerHour', obj.CostPerHour);
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'Cost', 0);
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, userLabelInput);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.Task1Grid, 'UserID', userLabelInput);
          },
          validation: function (_cell, valueMember, _row) {
            if (valueMember === "") {
              return { message: "User Name is Required" };
            } else {
              return true;
            }

          },
        },
        { text: 'UserID', datafield: 'UserID', width: '30%', editable: true, hidden: true },
        { text: 'Designation', datafield: 'Designation', width: '20%', editable: false },
        { text: 'Role', datafield: 'Role', width: '20%', editable: false },
        {
          text: 'RatePerHour', datafield: 'RatePerHour', width: '10%', editable: false, columntype: 'numberinput',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var NoOfHour = $(".Task1Grid").jqxGrid('getcellvalue', row, 'NoOfHour');
              var fvalue = newValue * NoOfHour;
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        {
          text: 'NoOfHour', datafield: 'NoOfHour', width: '10%', editable: true, cellsalign: 'right',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var RatePerHour = $(".Task1Grid").jqxGrid('getcellvalue', row, 'RatePerHour');
              var fvalue = newValue * RatePerHour;
              $(".Task1Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        { text: 'Cost', datafield: 'Cost', width: '10%', editable: false, cellsformat: 'd', cellsalign: 'right' },
      ];
    this.Task1GridSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'PDetailID', type: 'int' },
        { name: 'UserID', type: 'int' },
        { name: 'TransID', type: 'int' },
        { name: 'UserName', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Role', type: 'string' },
        { name: 'RatePerHour', type: 'int' },
        { name: 'NoOfHour', type: 'int' },
        { name: 'Cost', type: 'int' },
      ],
      id: 'task1id',
      localdata: [{
        "Designation": "",
        "Role": "",
      }]
      // localdata: ''
    };

    this.Task1GridAdapter = new $.jqx.dataAdapter(this.Task1GridSource);
    this.Task1GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'rateAdd',
          delete: 'rateDelete',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.Task1Grid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addRateGridNewRow,
          // deleteRowMethodObj: this.deleteRowRateGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    //  this.rateGridAdapter = new jqx.dataAdapter(this.ratesource);
  }

  Task2gridInint() {
    let userautourl = this.masteruri + '/userMaster/user-auto';
    let userLabelInput: any;
    this.Task2GridColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, editable: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'PDetailID', datafield: 'PDetailID', width: '5%', hidden: true },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        {
          text: 'UserName <span style="color:red">*</span>', width: '13%', datafield: 'UserName2', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            userLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, userautourl, 'UserName2', undefined, function (obj) {
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'Designation', obj.Designation);
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'NoOfHour', 0);
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'Role', obj.RoleName);
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'RatePerHour', obj.CostPerHour);
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'Cost', 0);
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, userLabelInput);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.Task2Grid, 'UserID', userLabelInput);
          },
          validation: function (_cell, valueMember, _row) {
            if (valueMember === "") {
              return { message: "User Name is Required" };
            } else {
              return true;
            }

          },
        },
        { text: 'UserID', datafield: 'UserID', width: '30%', editable: true, hidden: true },
        { text: 'Designation', datafield: 'Designation', width: '20%', editable: false },
        { text: 'Role', datafield: 'Role', width: '20%', editable: false },
        {
          text: 'RatePerHour', datafield: 'RatePerHour', width: '10%', editable: false, columntype: 'numberinput',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var NoOfHour = $(".Task2Grid").jqxGrid('getcellvalue', row, 'NoOfHour');
              var fvalue = newValue * NoOfHour;
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        {
          text: 'NoOfHour', datafield: 'NoOfHour', width: '10%', editable: true, cellsalign: 'right',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var RatePerHour = $(".Task2Grid").jqxGrid('getcellvalue', row, 'RatePerHour');
              var fvalue = newValue * RatePerHour;
              $(".Task2Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        { text: 'Cost', datafield: 'Cost', width: '10%', editable: false, cellsformat: 'd', cellsalign: 'right' },
      ];
    this.Task2GridSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'PDetailID', type: 'int' },
        { name: 'UserID', type: 'int' },
        { name: 'TransID', type: 'int' },
        { name: 'UserName2', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Role', type: 'string' },
        { name: 'RatePerHour', type: 'int' },
        { name: 'NoOfHour', type: 'int' },
        { name: 'Cost', type: 'int' },

      ],
      id: 'task2id',
      localdata: [{
        "Designation": "",
        "Role": "",
      }]
      // localdata: ''
    };

    this.Task2GridAdapter = new $.jqx.dataAdapter(this.Task2GridSource);
    this.Task2GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'rateAdd2',
          delete: 'rateDelete2',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.Task2Grid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addRateGridNewRow,
          // deleteRowMethodObj: this.deleteRowRateGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    // this.rateGridAdapter = new jqx.dataAdapter(this.ratesource);
  }

  Task3gridInint() {
    let userautourl = this.masteruri + '/userMaster/user-auto';
    let userLabelInput: any;
    this.Task3GridColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, editable: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'PDetailID', datafield: 'PDetailID', width: '5%', hidden: true },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        {
          text: 'UserName <span style="color:red">*</span>', width: '13%', datafield: 'UserName3', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            userLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, userautourl, 'UserName3', undefined, function (obj) {
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'Designation', obj.Designation);
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'NoOfHour', 0);
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'Role', obj.RoleName);
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'RatePerHour', obj.CostPerHour);
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'Cost', 0);
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, userLabelInput);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.Task3Grid, 'UserID', userLabelInput);
          },
          validation: function (_cell, valueMember, _row) {
            if (valueMember === "") {
              return { message: "User Name is Required" };
            } else {
              return true;
            }

          },
        },
        { text: 'UserID', datafield: 'UserID', width: '30%', editable: true, hidden: true },
        { text: 'Designation', datafield: 'Designation', width: '20%', editable: false },
        { text: 'Role', datafield: 'Role', width: '20%', editable: false },
        {
          text: 'RatePerHour', datafield: 'RatePerHour', width: '10%', editable: false, columntype: 'numberinput',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var NoOfHour = $(".Task3Grid").jqxGrid('getcellvalue', row, 'NoOfHour');
              var fvalue = newValue * NoOfHour;
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        {
          text: 'NoOfHour', datafield: 'NoOfHour', width: '10%', editable: true, cellsalign: 'right',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var RatePerHour = $(".Task3Grid").jqxGrid('getcellvalue', row, 'RatePerHour');
              var fvalue = newValue * RatePerHour;
              $(".Task3Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        { text: 'Cost', datafield: 'Cost', width: '10%', editable: false, cellsformat: 'd', cellsalign: 'right' },
      ];
    this.Task3GridSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'PDetailID', type: 'int' },
        { name: 'UserID', type: 'int' },
        { name: 'TransID', type: 'int' },
        { name: 'UserName3', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Role', type: 'string' },
        { name: 'RatePerHour', type: 'int' },
        { name: 'NoOfHour', type: 'int' },
        { name: 'Cost', type: 'int' },

      ],
      id: 'task3id',
      localdata: [{
        "Designation": "",
        "Role": "",
      }]
    };

    this.Task3GridAdapter = new $.jqx.dataAdapter(this.Task3GridSource);
    this.Task3GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'rateAdd3',
          delete: 'rateDelete3',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.Task3Grid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addRateGridNewRow,
          // deleteRowMethodObj: this.deleteRowRateGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    // this.rateGridAdapter = new jqx.dataAdapter(this.ratesource);
  }

  Task4gridInint() {
    let userautourl = this.masteruri + '/userMaster/user-auto';
    let userLabelInput: any;
    this.Task4GridColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, editable: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'PDetailID', datafield: 'PDetailID', width: '5%', hidden: true },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        {
          text: 'UserName <span style="color:red">*</span>', width: '13%', datafield: 'UserName4', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            userLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, userautourl, 'UserName4', undefined, function (obj) {
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'Designation', obj.Designation);
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'NoOfHour', 0);
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'Role', obj.RoleName);
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'RatePerHour', obj.CostPerHour);
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'Cost', 0);
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, userLabelInput);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.Task4Grid, 'UserID', userLabelInput);
          },
          validation: function (_cell, valueMember, _row) {
            if (valueMember === "") {
              return { message: "User Name is Required" };
            } else {
              return true;
            }

          },
        },
        { text: 'UserID', datafield: 'UserID', width: '30%', editable: true, hidden: true },
        { text: 'Designation', datafield: 'Designation', width: '20%', editable: false },
        { text: 'Role', datafield: 'Role', width: '20%', editable: false },
        {
          text: 'RatePerHour', datafield: 'RatePerHour', width: '10%', editable: false, columntype: 'numberinput',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var NoOfHour = $(".Task4Grid").jqxGrid('getcellvalue', row, 'NoOfHour');
              var fvalue = newValue * NoOfHour;
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        {
          text: 'NoOfHour', datafield: 'NoOfHour', width: '10%', editable: true, cellsalign: 'right',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var RatePerHour = $(".Task4Grid").jqxGrid('getcellvalue', row, 'RatePerHour');
              var fvalue = newValue * RatePerHour;
              $(".Task4Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        { text: 'Cost', datafield: 'Cost', width: '10%', editable: false, cellsformat: 'd', cellsalign: 'right' },
      ];
    this.Task4GridSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'PDetailID', type: 'int' },
        { name: 'UserID', type: 'int' },
        { name: 'TransID', type: 'int' },
        { name: 'UserName4', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Role', type: 'string' },
        { name: 'RatePerHour', type: 'int' },
        { name: 'NoOfHour', type: 'int' },
        { name: 'Cost', type: 'int' },

      ],
      id: 'task4id',
      localdata: [{
        "Designation": "",
        "Role": "",
      }]
    };

    this.Task41GridAdapter = new $.jqx.dataAdapter(this.Task4GridSource);
    this.Task4GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'rateAdd4',
          delete: 'rateDelete4',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.Task4Grid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addRateGridNewRow,
          // deleteRowMethodObj: this.deleteRowRateGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    // this.rateGridAdapter = new jqx.dataAdapter(this.ratesource);
  }

  Task5gridInint() {
    let userautourl = this.masteruri + '/userMaster/user-auto';
    let userLabelInput: any;
    this.Task5GridColumns =
      [
        {
          text: 'S.No', width: '10%', sortable: false, menu: false, editable: false, cellsrenderer: function (row, cell, value) {
            return '<div style="text-align: center; margin-top: 10px;">' + (1 + row) + '</div>';
          }
        },
        { text: 'PDetailID', datafield: 'PDetailID', width: '5%', hidden: true },
        { text: 'TransID', datafield: 'TransID', width: '5%', hidden: true },
        {
          text: 'UserName <span style="color:red">*</span>', width: '13%', datafield: 'UserName5', columntype: 'custom',
          createeditor: (row: number, cellvalue: any, editor: any, cellText: any, width: any, height: any): void => {
            userLabelInput = this.gridService.gridAutoCompleteCreateEditor(row, cellvalue, editor, cellText, width, height, userautourl, 'UserName5', undefined, function (obj) {
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'Designation', obj.Designation);
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'NoOfHour', 0);
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'Role', obj.RoleName);
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'RatePerHour', obj.CostPerHour);
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'Cost', 0);
            });
          },
          initeditor: (row: number, cellvalue: any, editor: any, celltext: any, pressedkey: any): void => {
            this.gridService.gridAutoCompleteInitEditor(row, cellvalue, editor, celltext, pressedkey, userLabelInput);
          },
          geteditorvalue: (row: number, cellvalue: any, editor: any): void => {
            return this.gridService.gridAutoCompleteGeteditorvalue(row, cellvalue, editor, this.Task5Grid, 'UserID', userLabelInput);
          },
          validation: function (_cell, valueMember, _row) {
            if (valueMember === "") {
              return { message: "User Name is Required" };
            } else {
              return true;
            }

          },
        },
        { text: 'UserID', datafield: 'UserID', width: '30%', editable: true, hidden: true },
        { text: 'Designation', datafield: 'Designation', width: '20%', editable: false },
        { text: 'Role', datafield: 'Role', width: '20%', editable: false },
        {
          text: 'RatePerHour', datafield: 'RatePerHour', width: '10%', editable: false, columntype: 'numberinput',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var NoOfHour = $(".Task5Grid").jqxGrid('getcellvalue', row, 'NoOfHour');
              var fvalue = newValue * NoOfHour;
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        {
          text: 'NoOfHour', datafield: 'NoOfHour', width: '10%', editable: true, cellsalign: 'right',
          cellendedit: function (row, colName, col, oldValue, newValue) {
            if (Number(newValue) != Number(oldValue)) {
              var RatePerHour = $(".Task5Grid").jqxGrid('getcellvalue', row, 'RatePerHour');
              var fvalue = newValue * RatePerHour;
              $(".Task5Grid").jqxGrid('setcellvalue', row, 'Cost', fvalue);
            }
          },
        },
        { text: 'Cost', datafield: 'Cost', width: '10%', editable: false, cellsformat: 'd', cellsalign: 'right' },
      ];
    this.Task5GridSource =
    {
      datatype: 'json',
      datafields: [
        { name: 'PDetailID', type: 'int' },
        { name: 'UserID', type: 'int' },
        { name: 'TransID', type: 'int' },
        { name: 'UserName5', type: 'string' },
        { name: 'Designation', type: 'string' },
        { name: 'Role', type: 'string' },
        { name: 'RatePerHour', type: 'int' },
        { name: 'NoOfHour', type: 'int' },
        { name: 'Cost', type: 'int' },

      ],
      id: 'task5id',
      localdata: [{
        "Designation": "",
        "Role": "",
      }]
    };

    this.Task5GridAdapter = new $.jqx.dataAdapter(this.Task5GridSource);
    this.Task5GridToolBar = (toolbar: any): void => {
      if (!this.commonService.isEmpty(toolbar)) {
        let buttonIdObj = {
          add: 'rateAdd5',
          delete: 'rateDelete5',
        }

        let tooBarObj = {
          currenComponentObj: this,
          gridObj: this.Task5Grid,
          toolbarObj: toolbar,
          buttonObj: buttonIdObj,
          gridTitle: "",
          addRowMethodObj: this.addRateGridNewRow,
          // deleteRowMethodObj: this.deleteRowRateGrid,
        }
        this.gridService.generateToolBar(tooBarObj);
      };
    }
    // this.rateGridAdapter = new jqx.dataAdapter(this.ratesource);
  }

  addRateGridNewRow(obj) {
    let row = {};
    row['UserName'] = ''
    row['Designation'] = ''
    return row;

  }
  //#endregion
}
